module.exports = __webpack_public_path__ + "media/newstyle/images/icon-feature-detail-54b2948895d919e9d62aff7c0af22fca.svg";